import React from 'react';
import { useWebSocketData } from '../context/WebSocketContext';
import {
  MdLaptop,
  MdSmartphone,
  MdTablet,
  MdPublic,
  MdVisibility,
  MdShowChart,
  MdLocationOn
} from 'react-icons/md';
import { FaChrome, FaFirefox, FaSafari, FaEdge, FaApple } from 'react-icons/fa';
import './Security.css';

function VisitLogs() {
  const { visits } = useWebSocketData();

  const getDeviceIcon = (device) => {
    if (!device) return <MdLaptop className="text-muted" />;
    const d = device.toLowerCase();
    if (d.includes('mobile') || d.includes('android') || d.includes('iphone')) return <MdSmartphone className="text-muted" />;
    if (d.includes('tablet') || d.includes('ipad')) return <MdTablet className="text-muted" />;
    return <MdLaptop className="text-muted" />;
  };

  const getBrowserIcon = (browser) => {
    if (!browser) return <MdPublic className="text-muted" />;
    const b = browser.toLowerCase();
    if (b.includes('chrome')) return <FaChrome className="text-muted" />;
    if (b.includes('firefox')) return <FaFirefox className="text-muted" />;
    if (b.includes('safari')) return <FaSafari className="text-muted" />;
    if (b.includes('edge')) return <FaEdge className="text-muted" />;
    if (b.includes('apple')) return <FaApple className="text-muted" />;
    return <MdPublic className="text-muted" />;
  };

  return (
    <div className="security-container">
      <div className="security-header">
        <div>
          <h3 className="security-title">
            <span className="live-dot me-2"></span> Visitor Logs
          </h3>
          <p className="text-muted mb-0">Real-time visitor activity monitoring</p>
        </div>
        <div className="d-flex gap-2">
          <span className="badge-security badge-location">
            <MdVisibility className="me-1" /> {visits.length} Active
          </span>
        </div>
      </div>

      {/* Visitor Logs Table */}
      <div className="security-card">
        <div className="security-card-header">
          <h6 className="security-card-title">
            <MdShowChart className="me-2" /> Live Activity Feed
          </h6>
        </div>

        {visits.length === 0 ? (
          <div className="text-center py-5">
            <div className="spinner-grow text-primary mb-3" role="status" style={{ width: '2rem', height: '2rem' }}>
              <span className="visually-hidden">Waiting...</span>
            </div>
            <h5 className="text-muted">Waiting for visitors...</h5>
            <p className="text-muted small">Real-time visitor data will appear here</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="security-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Project</th>
                  <th>Page</th>
                  <th>Device</th>
                  <th>Browser</th>
                  <th>Location</th>
                  <th>IP Address</th>
                </tr>
              </thead>
              <tbody>
                {visits.map((visit, index) => (
                  <tr key={index} style={index === 0 ? { background: 'rgba(66, 153, 225, 0.05)' } : {}}>
                    <td data-label="Time">
                      <span className="fw-medium text-dark">
                        {new Date(visit.timestamp || visit.createdAt).toLocaleTimeString()}
                      </span>
                    </td>
                    <td data-label="Project">
                      <span className="badge bg-light text-dark border">
                        {visit.projectDomain || 'Unknown'}
                      </span>
                    </td>
                    <td data-label="Page">
                      <code className="text-primary small">
                        {visit.page || '/'}
                      </code>
                    </td>
                    <td data-label="Device">
                      <span className="d-flex align-items-center gap-2">
                        {getDeviceIcon(visit.device)}
                        {visit.device || 'Unknown'}
                      </span>
                    </td>
                    <td data-label="Browser">
                      <span className="d-flex align-items-center gap-2">
                        {getBrowserIcon(visit.browser)}
                        {visit.browser || 'Unknown'}
                      </span>
                    </td>
                    <td data-label="Location">
                      <span className="badge-security badge-location">
                        <MdLocationOn className="me-1" /> {visit.country || visit.location || 'Unknown'}
                      </span>
                    </td>
                    <td data-label="IP Address">
                      <code className="text-muted small">
                        {visit.ip || 'N/A'}
                      </code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default VisitLogs;
